export default "__VITE_ASSET__f7801c1b__"